enum ModelCollectionNames {
  'donation' = 'donations',
  'file' = 'files',
  'workspaceProjectDocumentProofs' = 'workspace_project_document_proofs',
  'monitoringSystem' = 'monitoring_systems',
  'order' = 'orders',
  'role' = 'roles',
  'user' = 'users',
  'userInvite' = 'user_invites',
  'userWorkspaceRole' = 'user_workspace_roles',
  'workspace' = 'workspaces',
  'workspaceApiKey' = 'workspace_api_keys',
  'workspaceEmployee' = 'workspace_employees',
  'workspaceOrganization' = 'workspace_organizations',
  'workspaceOwnership' = 'workspace_ownership_transfers',
  'workspaceRole' = 'workspace_roles',
  'workspaceProject' = 'workspace_projects',
  'workspaceProjectAiAdviserUserPromptHistory' = 'workspace_project_ai_adviser_user_prompt_history',
  'workspaceProjectAiAdviserQuestionaire' = 'workspace_project_ai_adviser_questionnaire',
  'workspaceProjectAiChatFile' = 'workspace_project_ai_chat_file',
  'workspaceAiReportAssistantTemplate' = 'workspace_ai_report_assistant_template',
  'workspaceProjectAiReportAssistantDocument' = 'workspace_project_ai_report_assistant_document',
  'workspaceProjectAiReportAssistantChapter' = 'workspace_project_ai_report_assistant_chapter',
  'workspaceProjectAiReportAssistantSection' = 'workspace_project_ai_report_assistant_section',
  'workspaceProjectAiReportAssistantSubsection' = 'workspace_project_ai_report_assistant_subsection',
  'workspaceProjectAiReportAssistantSubsectionQuestion' = 'workspace_project_ai_report_assistant_subsection_question',
  'workspaceProjectAiReportAssistantQuestionReference' = 'workspace_project_ai_report_assistant_question_reference',
  'workspaceProjectBlock' = 'workspace_project_blocks',
  'workspaceProjectCarbonDeduction' = 'workspace_project_carbon_deduction_blocks',
  'workspaceProjectCarbonRemoval' = 'workspace_project_carbon_removal_blocks',
  'workspaceProjectCarbonRemovalPool' = 'workspace_project_carbon_removal_pools',
  'workspaceProjectCertification' = 'workspace_project_certifications',
  'workspaceProjectDatasetTransaction' = 'workspace_project_dataset_transactions',
  'workspaceProjectFundingMilestoneBatches' = 'workspace_project_funding_milestone_batches',
  'workspaceProjectFundingMilestoneBatchMilestones' = 'workspace_project_funding_milestones_batch_milestones',
  'workspaceProjectFundingMilestoneDeliverable' = 'workspace_project_funding_milestone_deliverables',
  'workspaceProjectGallery' = 'workspace_project_gallery',
  'workspaceProjectImpactFramework' = 'workspace_project_impact_framework',
  'workspaceProjectImpactFrameworkChainProblem' = 'workspace_project_impact_framework_chain_problems',
  'workspaceProjectImpactFrameworkChainImpact' = 'workspace_project_impact_framework_chain_impact',
  'workspaceProjectImpactFrameworkChainActivity' = 'workspace_project_impact_framework_chain_activities',
  'workspaceProjectImpactFrameworkChainResource' = 'workspace_project_impact_framework_chain_resources',
  'workspaceProjectImpactFrameworkComponentAdditionality' = 'workspace_project_impact_framework_component_additionality',
  'workspaceProjectImpactFrameworkComponentLeakage' = 'workspace_project_impact_framework_component_leakage',
  'workspaceProjectImpactFrameworkComponentPermanence' = 'workspace_project_impact_framework_component_permanence',
  'workspaceProjectImpactFrameworkComponentRisk' = 'workspace_project_impact_framework_component_risks',
  'workspaceProjectIntegrationDroneShots' = 'workspace_project_integration_drone_shots',
  'workspaceProjectIntegrationCluey' = 'workspace_project_integration_cluey',
  'workspaceProjectIntegrationGeoData' = 'workspace_project_integration_geo_data',
  'workspaceProjectIntegrationSatelliteImagery' = 'workspace_project_integration_satellite_images',
  'workspaceProjectMilestone' = 'workspace_project_milestones',
  'workspaceProjectMilestoneMultiIem' = 'workspace_project_milestone_multi_item',
  'workspaceProjectMilestonePayment' = 'workspace_project_milestone_payments',
  'workspaceProjectMilestoneRecipient' = 'workspace_project_milestone_recipients',
  'workspaceProjectMilestoneRelease' = 'workspace_project_milestone_release',
  'workspaceProjectSdg' = 'workspace_project_sdg',
  'workspaceProjectStakeholder' = 'workspace_project_stakeholders',
  'workspaceProjectAssetRegistry' = 'workspace_project_asset_registry',
  'workspaceProjectUpdate' = 'workspace_project_updates',
  'workspaceStripeProfile' = 'workspace_stripe_profile',
  'workspaceStripeSetupIntent' = 'workspace_stripe_setup_intents',
  'workspaceSubscription' = 'workspace_subscription',
  'workspaceProjectLandUseAgreement' = 'workspace_project_land_use_agreements',
  'workspaceProjectLandUseAndCarbonRightLegalStatus' = 'workspace_project_land_use_and_carbon_rights_legal_status',
  'workspaceProjectLandUseOwnershipAndCarbonRight' = 'workspace_project_land_use_ownership_and_carbon_rights',
  'workspaceProjectLandUseAndCarbonRightProtectedArea' = 'workspace_project_land_use_and_carbon_right_protected_area',
  'workspaceProjectAreaAndLandUseOverview' = 'workspace_project_area_and_land_use_overview',
  'workspaceProjectAreaAndLandUse' = 'workspace_project_area_and_land_use',
  'workspaceProjectAreaAndLandUsePopulation' = 'workspace_project_area_and_land_use_population',
  'workspaceProjectAreaAndLandUseSuitability' = 'workspace_project_area_and_land_use_suitability',
  'workspaceProjectCommunitiesPopulation' = 'workspace_project_communities_population',
  'workspaceProjectDistrict' = 'workspace_project_districts',
  'workspaceProjectVillage' = 'workspace_project_villages',
  'workspaceProjectMetric' = 'workspace_project_metrics',
  'workspaceProjectMetricMeasurementPoint' = 'workspace_project_metric_measurement_points',
  'workspaceProjectUtilityUnitOfMeasurement' = 'workspace_project_utility_unit_of_measurements',
  'workspaceProjectDocumentProofCustomType' = 'workspace_project_document_proof_custom_types',
  'workspaceProjectCommunitiesSocialSafeguard' = 'workspace_project_communities_social_safeguards',
  'workspaceSharingGroup' = 'workspace_sharing_groups',
}

export default ModelCollectionNames
